import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg"> & { strokeWidth?: number }

export const MediumPriority = forwardRef<SVGSVGElement, Props>(
	({ strokeWidth = 1.2, ...props }, ref) => (
		<svg
			width="15"
			height="15"
			viewBox="0 0 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<path
				d="M7.5 0.707107L14.2929 7.5L7.5 14.2929L0.707107 7.5L7.5 0.707107Z"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinejoin="round"
				fill="none"
			/>
			<path
				d="M7.5 3.53553L11.4645 7.5L7.5 11.4645L3.53553 7.5L7.5 3.53553Z"
				stroke="currentColor"
				strokeWidth={strokeWidth * 0.6}
				strokeLinejoin="round"
				fill="none"
			/>
		</svg>
	),
)
